export enum PrintBarcodeType {
  CODE_2_OF_5_INTERLEAVED = 'CODE_2_OF_5_INTERLEAVED',
  CODE_3_OF_9_STANDARD = 'CODE_3_OF_9_STANDARD',
  CODE_OMR = 'CODE_OMR',
}
